import { $ABTest } from '@lemon8/web-app-shared/atom';
import { Atom, atom } from 'jotai';
import _get from 'lodash/get';

/**
 * 0: control group
 * 1: proactivly trigger once load-more
 */
export const $HitRelatedPostLoadMore: Atom<boolean> = atom((get) => {
  const { parameters } = get($ABTest);
  if (__BUILD_TYPE__ === 'local_dev') {
    return true;
  }
  return Boolean(_get(parameters, ['seo_web', 'lemon8.related_load_more'], true));
});
